import axios from "axios";
import { cnxAPI, notifica, show_ldr, instance } from "../requests/utils";
import Swal from "sweetalert2";
import { Buffer } from "buffer";
import { postLoginCandidato } from "./login";
import api from "../service/api";

var a = null,
  b = null;
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const validaCandidato = async (data) => {
  const encode = Buffer.from(JSON.stringify(data)).toString("base64");
  console.log(process.env);
  let response = api.post("candidatos/validar", { Data: encode })
    .then((resp) => {
      const { data, status } = resp;
      if (status === 200) {
        return data.data ? data.data : true;
      }
      notifica("error", data?.message || "Error desconocido", "Alerta!");
      return null;
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    });
  return response;
};

export const registro = async (data) => {
  const encode = Buffer.from(JSON.stringify(data)).toString("base64");
  let response = await api
    .post("candidatos/agregar", { Data: encode })
    .then((resp) => {
      const { data, status } = resp;
      if (status === 200) {
        return data ? data : true;
      }
      notifica("error", data?.message || "Error desconocido", "Alerta!");
      return null;
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    });
  return response;
};

export const login = async (data) => {
  const response = await postLoginCandidato(data.Correo, data.Password)
    .then((resp) => {
      if (Object.keys(resp || {})?.length > 0) {
        return resp
      }
      notifica("error", resp ? "Usuario y/o contraseña incorrecto" : "Error desconocido", "Alerta!");
      return null;
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    });
  return response;
};

//Función que valida usuario y contraseña
function loginAuth(_callback) {
  var usr = document.getElementById("IdUsuario"),
    pss = document.getElementById("IdPass"),
    json = { Correo: usr.value, Password: pss.value };
  const codif = { Data: btoa(JSON.stringify(json)) };
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/CandidatoLogin",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: codif,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}

function LoginVerificacion(data, _callback) {
  var usr = data.usuario,
    pss = data.pass,
    json = { Correo: usr, Password: pss };
  let codif = { Data: btoa(JSON.stringify(json)) };
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/CandidatoLogin",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: codif,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}
function VerificacionCandidato(data, _callback) {
  var idCandidato = data.idCandidato,
    json = { idCandidato };
  //let codif = { Data: btoa(JSON.stringify(json)) };
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/ValidacionCandidatoNuevo",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}

//Función para registrar nuevo usuario

function newUser(_callback) {
  var nm = document.getElementById("nombre"),
    pat = document.getElementById("apellidoPaterno"),
    mat = document.getElementById("apellidoMaterno"),
    mail = document.getElementById("correo"),
    pass = document.getElementById("IdPass"),
    cdpstl = document.getElementById("codigoPostal"),
    telf = document.getElementById("Telefono1"),
    json = {
      nombre: nm.value,
      apellidoPaterno: pat.value,
      apellidoMaterno: mat.value,
      Correo: mail.value,
      Password: pass.value,
      codigoPostal: cdpstl.value,
      telefono1: telf.value,
    };
  let codif = { Data: btoa(JSON.stringify(json)) };
  api.post("candidatos/validar", codif)
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else if (response.data.message === "El correo ingresado no se encuentra registrado.") {
        Swal.fire({
          title: "",
          icon: "info",
          input: "checkbox",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          inputPlaceholder:
            'Acepto <a href="https://docreclutamiento.tiii.mx/AvisoPrivacidad/Aviso%20de%20Privacidad.pdf" target="_blank"> Aviso de Privacidad</a> ',
        }).then(function (result) {
          if (result.value) {
            show_ldr(true);
            api.post("candidatos/agregar", codif)
              .then(function (response) {
                show_ldr(false);
                if (response.status !== 200) {
                  notifica("warning", response.data.message, "Alerta!");
                } else {
                  b = response.data;
                }
                if (response.status === 200) {
                  Swal.fire({
                    icon: "success",
                    title: "¡Su cuenta se creo correctamente.!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                }
              })
              .catch(function (error) {
                notifica("danger", error, "Error");
              })
              .then(() => _callback(b));
          } else if (result.value === 0) {
            Swal.fire({
              icon: "error",
              title: "Necesitas aceptar Aviso de Privacidad",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      } else if (response.data.code === 1) {
        notifica("warning", response.data.message, "Alerta!");
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    });
}

function loginAuth2(_callback) {
  var usr = document.getElementById("correo"),
    pss = document.getElementById("IdPass"),
    json = { Correo: usr.value, Password: pss.value };
  let codif = { Data: btoa(JSON.stringify(json)) };
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/CandidatoLogin",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: codif,
  })
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}
function recuperaPass(_callback) {
  var usr = document.getElementById("IdUsuario"),
    json = { correo: usr.value };
  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/GetinfoC",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      show_ldr(false);

      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!");
      } else {
        a = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(a));
}

function axGuardarNuevaContrasena(contrasena, id) {
  show_ldr(true);
  let json = { idCandidato: id, Pass: contrasena };
  axios({
    method: "post",
    url: cnxAPI + "Candidato/SavePass",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: json,
  })
    .then(function (response) {
      if (response.data.code === 0) {
        Swal.fire({
          icon: "success",
          title: "Se ha cambiado la contraseña correctamente.",
          text: "Recibirás un correo de confirmación de cambio de contraseña",
        });
        show_ldr(false);
        sleep(3000).then(() => {
          window.location.href = "/";
        });
      } else {
        notifica("danger", response.data.message, "Error");
        show_ldr(false);
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
      show_ldr(false);
    });
}
/*****************************************************************/

function validarCorreo(datos) {
  instance
    .post("Candidato/Update", datos)
    .then((result) => {
      if (result.data.code === 0) {
        show_ldr(false);
        window.location.href = "/";
      } else {
        notifica("danger", result.data.message, "Error");
        show_ldr(false);
      }
    })
    .catch((err) => {
      notifica("danger", err, "Error");
      show_ldr(false);
    });
}

var menu = [
  {
    nombre: "Busca Ofertas",
    descripcion: "Encuentra ofertas de empleo",
    icono: "icon_ofertas.png",
    desc_url: "ofertas",
  },
  {
    nombre: "Curriculum",
    descripcion: "Perfil del usuario",
    icono: "icon_perfil.png",
    desc_url: "perfil",
  },
  {
    nombre: "Postulaciones",
    descripcion: "Mira las postulaciones realizadas",
    icono: "icon_postulaciones.png",
    desc_url: "postulaciones",
  },
  {
    nombre: "Alertas",
    descripcion: "Alertas de nuevas ofertas",
    icono: "icon_alertas.png",
    desc_url: "alertas",
  },
  {
    nombre: "Notificaciones",
    descripcion: "Recibe notificaciones",
    icono: "icon_notificacion.png",
    desc_url: "notificaciones",
  },
];

export {
  recuperaPass,
  loginAuth,
  loginAuth2,
  menu,
  newUser,
  axGuardarNuevaContrasena,
  validarCorreo,
  LoginVerificacion,
  VerificacionCandidato,
};
